var ordersData = [{
  Status: "Completed",
  OrderNumber: "17711249595187200",
  OrderDate: "Apr 19, 2023",
  Id: "Entity-Order-e2cf3f97bbf24477a641331e12895e94",
  CartLines: [{
    Id: "169027dd367841a7b2339827136de506",
    Product: {
      SitecoreId: "90a58e8a-23ec-7cf1-cd23-2c6a01f5f252",
      ProductChainId: "486175",
      StoreProductId: "16395128",
      ProductVariantId: null,
      DisplayName: "Coca-Cola®",
      AvailableInventory: 0,
      CurrencySymbol: "USD",
      ListPrice: 0,
      AdjustedPrice: null,
      ImageFilePath: "https://olo-images-sandbox.imgix.net/87/87d842dcac634631a5b7ccfa20812b75.jpg?auto=format%2Ccompress&q=60&cs=tinysrgb&w=120&h=120&fit=fill&fm=png32&bg=transparent&s=361573af8ce60f426fae0e7f6dd6f0e2",
      MinimumQuantity: "1",
      MaximumQuantity: "0",
      MinimumBasketQuantity: "0",
      MaximumBasketQuantity: "0",
      DetailLink: "/menu/drinks/sodas/coca-cola®?productid=16395128",
      CatalogName: "CB_Food_Store",
      ProductVariantModel: null,
      AdvanceNoticeTimeInHours: "0"
    },
    Quantity: 1,
    Price: {
      CurrencyCode: "USD",
      CurrencySymbol: "$",
      Total: 0,
      Subtotal: 2.99,
      HandlingTotal: 0,
      ShippingTotal: 0,
      TaxTotal: 0,
      TotalSavings: 0,
      OloTip: null,
      OloCateringTip: null
    },
    Options: null,
    LineCost: 2.99,
    OloBasketId: "27780cf6-6e16-4b30-aeec-35ffad250a32",
    OloBasketProductId: "10038164193",
    Recipient: null,
    SpecialInstruction: null,
    LineOptions: null,
    TrackingNumber: null,
    AddOnProductDetails: null,
    ReturnDetails: {
      Quantity: 0,
      ReturnWindowExpired: false,
      Status: "",
      IsReturnInitiated: false,
      Reason: ""
    }
  }],
  Price: {
    CurrencyCode: "USD",
    CurrencySymbol: "$",
    GiftCardTotal: 3.28,
    Total: 3.28,
    Subtotal: 2.99,
    HandlingTotal: 0,
    ShippingTotal: 0,
    TaxTotal: 0,
    TotalSavings: 0,
    OloTip: null,
    OloCateringTip: null
  },
  Adjustments: [],
  Email: null,
  Addresses: [{
    Name: "",
    FirstName: "Esteban",
    LastName: "Flores",
    Address1: "28 DAMRELL STREET, SUITE 300",
    Address2: "",
    Country: "",
    CountryCode: "",
    City: "Boston",
    State: "",
    ZipPostalCode: "02127",
    ExternalId: "",
    PartyId: "",
    IsPrimary: false,
    Email: "esteban.flores@verndale.com",
    ContactId: null
  }, {
    Name: "",
    FirstName: "Esteban",
    LastName: "Flores",
    Address1: "28 DAMRELL STREET, SUITE 300",
    Address2: "",
    Country: "",
    CountryCode: "",
    City: "Boston",
    State: "",
    ZipPostalCode: "02127",
    ExternalId: "",
    PartyId: "",
    IsPrimary: false,
    Email: "esteban.flores@verndale.com",
    ContactId: null
  }],
  Shippings: null,
  Options: null,
  OloFoodStoreBasketId: null,
  OloCateringStoreBasketId: null,
  OloErrors: null,
  FoodDelivery: null,
  OloDiscount: null,
  OloStoreComponent: {
    StoreName: "Lab 1020",
    StoreNumber: "1020",
    StoreAddress: "305 Hartmann Drive",
    StoreCity: "Lebanon",
    State: "TN",
    ZipCode: "37087",
    StorePhone: "6154445533",
    MerchantId: null,
    VendorId: "143963",
    StoreTimeZone: "-5",
    Id: "a7cffc94025648f597ec2e08a6a8f83e",
    Name: "",
    Comments: "",
    Policies: [],
    ChildComponents: []
  },
  UserIp: null,
  DisplayMessages: null,
  UpsellCrossSellCategories: null,
  IsTokenExEnabled: false
}, {
  Status: "Completed",
  OrderNumber: "17574530122743811",
  OrderDate: "Apr 13, 2023",
  Id: "Entity-Order-409bf2e0977d4499b87ab64fe3e852aa",
  CartLines: [{
    Id: "b4de4f9846cb474e9e4b33eacef62fc9",
    Product: {
      SitecoreId: null,
      ProductChainId: null,
      StoreProductId: "40510276",
      ProductVariantId: null,
      DisplayName: null,
      AvailableInventory: 0,
      CurrencySymbol: null,
      ListPrice: null,
      AdjustedPrice: null,
      ImageFilePath: null,
      MinimumQuantity: null,
      MaximumQuantity: null,
      MinimumBasketQuantity: null,
      MaximumBasketQuantity: null,
      DetailLink: null,
      CatalogName: "CB_Food_Store",
      ProductVariantModel: null,
      AdvanceNoticeTimeInHours: null
    },
    Quantity: 1,
    Price: {
      CurrencyCode: "USD",
      CurrencySymbol: "$",
      Total: 0,
      Subtotal: 15.99,
      HandlingTotal: 0,
      ShippingTotal: 0,
      TaxTotal: 0,
      TotalSavings: 0,
      OloTip: null,
      OloCateringTip: null
    },
    Options: null,
    LineCost: 15.99,
    OloBasketId: "48c272d3-cd9b-4ff5-a2d6-3c27110f2d39",
    OloBasketProductId: "15939039897",
    Recipient: null,
    SpecialInstruction: null,
    LineOptions: null,
    TrackingNumber: null,
    AddOnProductDetails: null,
    ReturnDetails: {
      Quantity: 0,
      ReturnWindowExpired: false,
      Status: "",
      IsReturnInitiated: false,
      Reason: ""
    }
  }],
  Price: {
    CurrencyCode: "USD",
    CurrencySymbol: "$",
    GiftCardTotal: 17.55,
    Total: 17.55,
    Subtotal: 15.99,
    HandlingTotal: 0,
    ShippingTotal: 0,
    TaxTotal: 0,
    TotalSavings: 0,
    OloTip: null,
    OloCateringTip: null
  },
  Adjustments: [],
  Email: null,
  Addresses: [{
    Name: "",
    FirstName: "Esteban",
    LastName: "Flores",
    Address1: "28 DAMRELL STREET, SUITE 300",
    Address2: "",
    Country: "",
    CountryCode: "",
    City: "Boston",
    State: "",
    ZipPostalCode: "02127",
    ExternalId: "",
    PartyId: "",
    IsPrimary: false,
    Email: "esteban.flores@verndale.com",
    ContactId: null
  }, {
    Name: "",
    FirstName: "Esteban",
    LastName: "Flores",
    Address1: "28 DAMRELL STREET, SUITE 300",
    Address2: "",
    Country: "",
    CountryCode: "",
    City: "Boston",
    State: "",
    ZipPostalCode: "02127",
    ExternalId: "",
    PartyId: "",
    IsPrimary: false,
    Email: "esteban.flores@verndale.com",
    ContactId: null
  }],
  Shippings: null,
  Options: null,
  OloFoodStoreBasketId: null,
  OloCateringStoreBasketId: null,
  OloErrors: null,
  FoodDelivery: null,
  OloDiscount: null,
  OloStoreComponent: {
    StoreName: "Ops Lab 8102",
    StoreNumber: "8102",
    StoreAddress: "305 Hartmann Drive",
    StoreCity: "Lebanon",
    State: "TN",
    ZipCode: "37087",
    StorePhone: "6154445533",
    MerchantId: null,
    VendorId: "129973",
    StoreTimeZone: "-5",
    Id: "8c4d7da6a3a1417db4585eb168fc269e",
    Name: "",
    Comments: "",
    Policies: [],
    ChildComponents: []
  },
  UserIp: null,
  DisplayMessages: null,
  UpsellCrossSellCategories: null,
  IsTokenExEnabled: false
}, {
  Status: "Completed",
  OrderNumber: "17324659652100097",
  OrderDate: "Apr 02, 2023",
  Id: "Entity-Order-cdeef6404a5b4825a51a15db0df13198",
  CartLines: [{
    Id: "9cf1d26c8a2e4b599c64f66f2db17ec2",
    Product: {
      SitecoreId: null,
      ProductChainId: null,
      StoreProductId: "40510275",
      ProductVariantId: null,
      DisplayName: null,
      AvailableInventory: 0,
      CurrencySymbol: null,
      ListPrice: null,
      AdjustedPrice: null,
      ImageFilePath: null,
      MinimumQuantity: null,
      MaximumQuantity: null,
      MinimumBasketQuantity: null,
      MaximumBasketQuantity: null,
      DetailLink: null,
      CatalogName: "CB_Food_Store",
      ProductVariantModel: null,
      AdvanceNoticeTimeInHours: null
    },
    Quantity: 1,
    Price: {
      CurrencyCode: "USD",
      CurrencySymbol: "$",
      Total: 0,
      Subtotal: 19.99,
      HandlingTotal: 0,
      ShippingTotal: 0,
      TaxTotal: 0,
      TotalSavings: 0,
      OloTip: null,
      OloCateringTip: null
    },
    Options: null,
    LineCost: 19.99,
    OloBasketId: "748ffb16-99d3-4f1e-ada3-b47996bb8d9b",
    OloBasketProductId: "15844014028",
    Recipient: null,
    SpecialInstruction: null,
    LineOptions: null,
    TrackingNumber: null,
    AddOnProductDetails: null,
    ReturnDetails: {
      Quantity: 0,
      ReturnWindowExpired: false,
      Status: "",
      IsReturnInitiated: false,
      Reason: ""
    }
  }, {
    Id: "c1dab4cc967945d180ad0daaf7223685",
    Product: {
      SitecoreId: null,
      ProductChainId: null,
      StoreProductId: "40510277",
      ProductVariantId: null,
      DisplayName: null,
      AvailableInventory: 0,
      CurrencySymbol: null,
      ListPrice: null,
      AdjustedPrice: null,
      ImageFilePath: null,
      MinimumQuantity: null,
      MaximumQuantity: null,
      MinimumBasketQuantity: null,
      MaximumBasketQuantity: null,
      DetailLink: null,
      CatalogName: "CB_Food_Store",
      ProductVariantModel: null,
      AdvanceNoticeTimeInHours: null
    },
    Quantity: 1,
    Price: {
      CurrencyCode: "USD",
      CurrencySymbol: "$",
      Total: 0,
      Subtotal: 15.99,
      HandlingTotal: 0,
      ShippingTotal: 0,
      TaxTotal: 0,
      TotalSavings: 0,
      OloTip: null,
      OloCateringTip: null
    },
    Options: null,
    LineCost: 15.99,
    OloBasketId: "748ffb16-99d3-4f1e-ada3-b47996bb8d9b",
    OloBasketProductId: "15844022786",
    Recipient: null,
    SpecialInstruction: null,
    LineOptions: null,
    TrackingNumber: null,
    AddOnProductDetails: null,
    ReturnDetails: {
      Quantity: 0,
      ReturnWindowExpired: false,
      Status: "",
      IsReturnInitiated: false,
      Reason: ""
    }
  }],
  Price: {
    CurrencyCode: "USD",
    CurrencySymbol: "$",
    GiftCardTotal: 23.89,
    Total: 44.89,
    Subtotal: 35.98,
    HandlingTotal: 0,
    ShippingTotal: 0,
    TaxTotal: 0,
    TotalSavings: 0,
    OloTip: null,
    OloCateringTip: null
  },
  Adjustments: [],
  Email: null,
  Addresses: [{
    Name: "",
    FirstName: "Esteban",
    LastName: "Flores",
    Address1: "28 DAMRELL STREET, SUITE 300",
    Address2: "",
    Country: "",
    CountryCode: "",
    City: "Boston",
    State: "",
    ZipPostalCode: "02127",
    ExternalId: "",
    PartyId: "",
    IsPrimary: false,
    Email: "esteban.flores@verndale.com",
    ContactId: null
  }, {
    Name: "",
    FirstName: "Esteban",
    LastName: "Flores",
    Address1: "28 DAMRELL STREET, SUITE 300",
    Address2: "",
    Country: "",
    CountryCode: "",
    City: "Boston",
    State: "",
    ZipPostalCode: "02127",
    ExternalId: "",
    PartyId: "",
    IsPrimary: false,
    Email: "esteban.flores@verndale.com",
    ContactId: null
  }],
  Shippings: null,
  Options: null,
  OloFoodStoreBasketId: null,
  OloCateringStoreBasketId: null,
  OloErrors: null,
  FoodDelivery: null,
  OloDiscount: null,
  OloStoreComponent: {
    StoreName: "Ops Lab 8102",
    StoreNumber: "8102",
    StoreAddress: "305 Hartmann Drive",
    StoreCity: "Lebanon",
    State: "TN",
    ZipCode: "37087",
    StorePhone: "6154445533",
    MerchantId: null,
    VendorId: "129973",
    StoreTimeZone: "-5",
    Id: "a96020db9e7b4f9d88f5f1503c7af8c3",
    Name: "",
    Comments: "",
    Policies: [],
    ChildComponents: []
  },
  UserIp: null,
  DisplayMessages: null,
  UpsellCrossSellCategories: null,
  IsTokenExEnabled: false
}];
var missingCreditDataOld = {
  logo: {
    value: {
      src: "https://i.ibb.co/XpxqNkW/Logo.png",
      alt: "Logo rewards",
      width: "223",
      height: "74"
    }
  },
  onPressAction: {
    value: "crackerbarrel://connect/Contact-Us"
  },
  contactButtonLink: {
    value: "https://guestrelations.crackerbarrel.com/s/contactsupport"
  },
  header: {
    value: "Are you missing PEG credit?"
  },
  description: {
    value: "<p>You can request missing Peg credit up to 30 days after a transaction:</p><ul><li>Please allow 48-72 hours after your transaction for Pegs to appear in your account. Then, check your order history to be sure you didn&rsquo;t receive credit.</li><li>After 72 hours, if Pegs are still missing, go to the &quot;Contact Us&quot; form and choose the &ldquo;Rewards Category&rdquo; in the first field and &ldquo;Missing Pegs&rdquo; in the topic field.</li><li>Be sure to provide your online order number or receipt number in the Comment/Question area.</li></ul>"
  },
  contactButtonLabel: {
    value: "Contact Us"
  },
  legalInfoCopy: {
    value: "<p>Placeholder for any legal language that we need to include to clarify like, please refer to Rewards<a href='http://www.google.com' target='_blank' rel='noopener noreferrer'> Terms and Conditions</a>.</p>"
  }
};
var missingCreditData = {
  Headline: {
    value: "Are you missing PEG credit?"
  },
  Header: [{
    id: "4f7d36ed-4366-4915-a577-03e2a2851fa2",
    fields: {
      ModuleTitle: {
        value: "Missing Peg Credit"
      },
      Image: {
        value: {
          src: "https://i.ibb.co/XpxqNkW/Logo.png",
          alt: "logo"
        }
      }
    }
  }],
  Copy: {
    value: "<ul>" + "<li>You will need your receipt or online order confirmation.</li>" + "<li>You can request missing Peg credit up to 30 days after a transaction.</li>" + "<li>Your order must have been placed after you became a Cracker Barrel Rewards Member.</li>" + "</ul>"
  },
  InStoreCTA: {
    value: "In-Store Visit"
  },
  OnlineOrderCTA: {
    value: "Online Order"
  },
  DisclaimerText: {
    value: "<p>It can take up to 48 hours for pegs to be added to your account. Orders made on shop.crackerbarrel.com will be awarded Pegs when the order ships. <a href='http://www.google.com' target='_blank' rel='noopener noreferrer'> Terms and Conditions</a>.</p>"
  },
  ReceiptScan400PegsNoticeModal: [{
    fields: {
      Headline: {
        value: 'Peg Limit Notice'
      },
      Copy: {
        value: 'Wow, you’re getting close to 500 Pegs. Please note that you may not have more than 500 Pegs in your account at any time. Consider redeeming some Pegs before requesting Peg credit from a past visit.</br></br>For more information please refer to the <a href=\'#\'>Terms and Conditions</a>.'
      },
      ButtonLink: {
        value: {
          "href": "/rewards",
          "text": "GOT IN",
          "anchor": "",
          "linktype": "internal",
          "class": "",
          "title": "",
          "target": "",
          "querystring": "",
          "id": "{68F8E750-774F-40FC-966D-95EADB3F1374}"
        }
      },
      ButtonLabel: {
        value: 'Got It'
      }
    }
  }],
  InStoreComponent: [{
    fields: {
      MobileCopy: {
        value: "Scan receipt to earn Pegs for your in-store visit"
      },
      Image: {
        value: {
          src: "https://via.placeholder.com/152x273.png",
          alt: "In store Image",
          width: "152",
          height: "273"
        }
      },
      Copy: {
        value: "Scan the Order Number barcode found at the bottom of your receipt."
      },
      ScanBarcodeCTA: {
        value: "Scan Barcode"
      },
      OrderNumberCopy: {
        value: "Enter the 17-digit number found below the barcode on your receipt.<br><br>If you paid using Mobile Pay, enter the order number found in your emailed receipt."
      },
      HintText: {
        value: "Order Number"
      },
      ErrorMessage: {
        value: "Please enter a valid order number"
      },
      TitleCTA: {
        value: "Submit"
      },
      Disclaimer: {
        value: "Pegs may not be earned on orders made through third-party services (Doordash, Grubhub, etc.). Orders made on shop.crackerbarrel.com will be awarded Pegs when the order ships. <a href=\'#\'>Terms and Conditions</a>"
      }
    }
  }],
  OnlineOrderComponent: [{
    fields: {
      MobileCopy: {
        value: "Enter order number for your online purchase"
      },
      Image: {
        value: {
          src: "https://via.placeholder.com/167x190.png",
          alt: "In store Image",
          width: "167",
          height: "190"
        }
      },
      Copy: {
        value: "Enter the Order Number found in your order confirmation email.<br><br>This number will be 17 digits for to-go or catering orders, and 7 digits for retail orders."
      },
      HintText: {
        value: "Order Number"
      },
      ErrorMessage: {
        value: "Please enter a valid order number"
      },
      SubmitCTA: {
        value: "Submit"
      },
      Disclaimer: {
        value: "Pegs may not be earned on orders made through third-party services. Orders made on shop.crackerbarrel.com will be awarded Pegs when the order ships. <a href=\'#\'>Terms and Conditions</a>"
      }
    }
  }],
  ReceiptScanPegsAwardedModal: [{
    fields: {
      ModalTitle: {
        value: 'Hooray'
      },
      Image: {
        value: {
          src: "https://via.placeholder.com/102x97.png",
          alt: "bg shape star",
          width: "102",
          height: "97"
        }
      },
      Headline: {
        value: 'You Earned $pegs Pegs'
      },
      Copy: {
        value: 'Your Pegs are in your account. Use ‘em up for the reward you want.'
      },
      ButtonLabel: {
        value: 'Got it'
      },
      ButtonLink: {
        value: {
          'href': '',
          'text': 'Got It',
          'linktype': 'external',
          'url': '',
          'anchor': '',
          'title': 'Got It',
          'target': ''
        }
      }
    }
  }],
  ReceiptScanLoadingAnimation: [{
    fields: {
      Copy: {
        value: 'Your request timed out, please try again.'
      },
      Description: {
        value: 'Something went wrong on our End'
      },
      Header: {
        value: 'Uh-Oh!'
      },
      RetryCTA: {
        value: 'Retry'
      }
    }
  }],
  ReceiptScanPegsPreviouslyRewardedModal: [{
    fields: {
      Headline: {
        value: 'Pegs already earned'
      },
      Copy: {
        value: 'This order has been awarded Pegs. Check your Rewards Activity to see full Rewards history.'
      },
      PrimaryCTA: {
        value: 'Got it'
      },
      SecondaryCTA: {
        value: 'Take me to rewards activity'
      },
      PrimaryLink: {
        value: {
          'href': '/',
          'text': 'Take me to rewards activity',
          'linktype': 'external',
          'url': '/rewards',
          'anchor': '',
          'title': 'Take me to rewards activity',
          'target': ''
        }
      },
      SecondaryLink: {
        value: {
          'href': '/rewards',
          'text': 'Take me to rewards activity',
          'linktype': 'external',
          'url': '/rewards',
          'anchor': '',
          'title': 'Take me to rewards activity',
          'target': ''
        }
      },
      Disclaimer: {
        value: 'Can\'t find it in Rewards Activity? Please <a href="#">contact Guest Relations</a> for assistance.'
      }
    }
  }],
  ReceiptScanDailyLimitReachedModal: [{
    fields: {
      Headline: {
        value: 'Daily Limit Reached'
      },
      Copy: {
        value: 'Pegs may be earned on a maximum of 5 Cracker Barrel Rewards™ transactions per day. You may still redeem rewards and place orders, but you cannot earn more Pegs today.</br></br>You’ll be back to earning Pegs tomorrow. For more information, please review the <a href=\'#\'>Terms and Conditions</a>.'
      },
      ButtonLabel: {
        value: 'Got it'
      },
      ButtonLink: {
        value: {
          "href": "/rewards",
          "text": "",
          "anchor": "",
          "linktype": "internal",
          "class": "",
          "title": "",
          "target": "",
          "querystring": "",
          "id": "{68F8E750-774F-40FC-966D-95EADB3F1374}"
        }
      }
    }
  }],
  ReceiptScan500PegsMaxModal: [{
    fields: {
      Headline: {
        value: 'Wow, you have earned 500 Pegs'
      },
      Copy: {
        value: '500 Pegs is the most you can have in your account at any time. To keep earning Pegs, you\'ll need to redeem some first.</br></br>You’ll be back to earning Pegs tomorrow. For more information please refer to the <a href=\'#\'>Terms and Conditions</a>.'
      },
      PrimaryLabel: {
        value: 'See my rewards'
      },
      PrimaryButton: {
        value: {
          'href': '/rewards',
          'text': 'See My Rewards',
          'linktype': 'external',
          'url': '/rewards',
          'anchor': '',
          'title': 'Sign In',
          'target': ''
        }
      },
      SecondaryButton: {
        value: {
          "href": "/",
          "text": "Got it",
          "anchor": "",
          "linktype": "internal",
          "class": "",
          "title": "",
          "target": "",
          "querystring": "",
          "id": "{5E561F82-2540-555B-8F59-1F4B29A5B7A1}"
        }
      },
      SecondaryLabel: {
        value: 'Got it'
      },
      PegCount: {
        value: '500'
      }
    }
  }],
  ReceiptScanReceiptExpiredModal: [{
    fields: {
      Headline: {
        value: 'Past 30 day limit'
      },
      Copy: {
        value: 'Placeholder message 30 day limit.'
      },
      ButtonLabel: {
        value: 'Got it'
      },
      ButtonLink: {
        value: {
          "href": "/",
          "text": "",
          "anchor": "",
          "linktype": "internal",
          "class": "",
          "title": "",
          "target": "",
          "querystring": "",
          "id": "{5E561F82-2540-555B-8F59-1F4B29A5B7A1}"
        }
      }
    }
  }],
  ReceiptScanLoyaltyAccountNotActiveModal: [{
    fields: {
      Headline: {
        value: 'Order placed before account creation'
      },
      Copy: {
        value: 'Placeholder message. To earn Pegs for an order, your account must have been created the day of or prior to the order being placed.'
      },
      "ButtonLink": {
        "value": {
          "href": "/rewards",
          "text": "",
          "anchor": "",
          "linktype": "internal",
          "class": "",
          "title": "",
          "target": "",
          "querystring": "",
          "id": "{68F8E750-774F-40FC-966D-95EADB3F1374}"
        }
      },
      "ButtonLabel": {
        "value": "Got it"
      }
    }
  }],
  ReceiptScanReceiptScanModal: [{
    fields: {
      Headline: {
        value: 'Missing Pegs'
      },
      Copy: {
        value: 'Scan your receipt to redeem missing Pegs.'
      },
      ScanHeadline: {
        value: "Place your receipt with the barcode in the box below"
      },
      ScanCopy: {
        value: "The barcode is at the bottom of your receipt."
      }
    }
  }],
  ReceiptScanReceiptNotFoundModal: [{
    fields: {
      Headline: {
        value: "Hmmm. We can't find that receipt"
      },
      Copy: {
        value: 'It can take up to 15 minutes for receipts to be available for Peg credit. Please wait a few more minutes and try again.'
      },
      PrimaryCTA: {
        value: 'Got it'
      },
      PrimaryLink: {
        value: {
          'href': '',
          'text': '',
          'linktype': 'internal',
          'url': '',
          'anchor': '',
          'title': '',
          'target': ''
        }
      },
      Disclaimer: {
        value: 'Still having problems getting credit? Please <a href="#">contact Guest Relations</a> for assistance.'
      }
    }
  }]
};
var pegModuleData = {
  freeOrderCopy: {
    value: "Your entire order is on the house!"
  },
  notLoggedInCopy: {
    value: "Sign in to earn Pegs for Rewards."
  },
  pausedAccCopy: {
    value: "You aren't able to earn while your account is paused."
  },
  backgroundShape: {
    value: {
      src: "https://eus-rsg-9cd37598e2c0-xc2-dev-cd.azurewebsites.net/-/media/CrackerBarrel/Rewards/bg-star.png?h=156&w=158&hash=3DF7B54F7069D56AA871A1F8ADA71280",
      alt: "bg shape star",
      width: "158",
      height: "156"
    }
  },
  backgroundImage: {
    value: {
      src: "https://eus-rsg-9cd37598e2c0-xc2-dev-cd.azurewebsites.net/-/media/CrackerBarrel/Rewards/bg.jpg?h=407&w=640&hash=0DEFE91264CBEF031695CCD6CB3BD2FA",
      alt: "background",
      width: "640",
      height: "407"
    }
  },
  orderDetailCopy: {
    value: "You earned # Pegs for this order."
  },
  signInLink: {
    value: {
      href: ""
    }
  },
  imageFreeOrder: {
    value: {
      src: "https://eus-rsg-9cd37598e2c0-xc2-dev-cd.azurewebsites.net/-/media/CrackerBarrel/Rewards/enjoyImage.png?h=74&w=93&hash=9B905553003FA1532CA9AA44A5AAEC6A",
      alt: "bg shape enjoy",
      width: "93",
      height: "74"
    }
  },
  image: {
    value: {
      src: "https://eus-rsg-9cd37598e2c0-xc2-dev-cd.azurewebsites.net/-/media/Project/cb-brandsite/brandsite/images/Loyalty/rewards.png?h=147&w=438&hash=466E11D5D6FB0114EA9B11F5CB421AF8",
      alt: "Rewards Logo",
      width: "438",
      height: "147"
    }
  },
  loggedInCopy: {
    value: "You will earn # Pegs for this order."
  },
  pegCounter: {
    value: "# PEGS"
  },
  infoButton: {
    value: {
      href: ""
    }
  },
  dailyLimitCopy: {
    value: "Daily transaction limit reached. You’ll be back to earning Pegs tomorrow."
  },
  checkoutCopy: {
    value: "You'll earn partial credit for this order as it brings you over 500 Pegs."
  },
  noPegsEarnedCopy: {
    value: "Your account has reached 500 pegs, the most it can have at one time. Redeem some, then keep on earning!."
  }
};
export { ordersData, missingCreditData, missingCreditDataOld, pegModuleData };